import { render, staticRenderFns } from "./SyncProgram.vue?vue&type=template&id=540061fc&scoped=true"
import script from "./SyncProgram.vue?vue&type=script&lang=js"
export * from "./SyncProgram.vue?vue&type=script&lang=js"
import style0 from "./SyncProgram.vue?vue&type=style&index=0&id=540061fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540061fc",
  null
  
)

export default component.exports